const carousels = {};
  
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.carousel').forEach(c => {
        const slides = c.querySelector('.carousel__slides');
        const dots = c.querySelectorAll('.carousel__nav button');
        let current = 0;
        
        const goTo = i => {
        current = i;
        slides.style.transform = `translateX(-${i * 100}%)`;
        dots.forEach((d, j) => d.classList.toggle('active', j === i));
        };
        
        carousels[c.id] = {
        goTo,
        next: () => goTo((current + 1) % slides.children.length),
        prev: () => goTo((current - 1 + slides.children.length) % slides.children.length)
        };
        
        // Autoplay functionality only
        if (c.dataset.autoplay === 'true') {
        let interval = setInterval(carousels[c.id].next, parseInt(c.dataset.speed) || 5000);
        c.addEventListener('mouseenter', () => clearInterval(interval));
        c.addEventListener('mouseleave', () => interval = setInterval(carousels[c.id].next, parseInt(c.dataset.speed) || 5000));
        }
    });
});

window.carouselNavigate = (id, dir) => carousels[id]?.[dir > 0 ? 'next' : 'prev']();
window.carouselGoToSlide = (id, index) => carousels[id]?.goTo(index);